<span *ngIf="expense.isWip && expense.state === ExpenseClaimState.Pending" class="label submitted-date">
              Set as WIP by {{ expense.wipActionedByFirstname }} {{ expense.wipActionedByLastname }}
  on {{ expense.wipDate | date: 'd MMM yyyy' }} at {{ expense.wipDate | date: 'h:mm aaa'}}
            </span>

<div class="reason-for-edit" *ngIf="expense.reasonsForEdit.length > 0">
  <label><i class="fas fa-pencil" aria-hidden="true"></i> Reasons for edit</label>
  <ul>
    <li *ngFor="let reason of expense.reasonsForEdit">
      {{ getLocalDate(reason.created) | date: 'd MMM yyyy' }} at {{ getLocalDate(reason.created) | date: 'h:mm aaa' }} -
      {{reason.reason}}
    </li>
  </ul>
</div>
